import { Component, OnInit, ViewChild } from '@angular/core';
import { BarBgComponent } from '../bar-bg/bar-bg.component';

@Component({
  selector: 'progres-container',
  templateUrl: './progres-container.component.html',
  styleUrls: ['./progres-container.component.css']
})
export class ProgresContainerComponent implements OnInit {

  @ViewChild('barBg', {static: false}) barBg:BarBgComponent;
  
  constructor() { }

  ngOnInit() {
  }

}
